import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      viewBox="0 0 70 70"
      fill="none"
      version="1.1"
      id="svg334"
      xmlns="http://www.w3.org/2000/svg">
      <defs id="defs338" />
      <g id="Icon">
        <circle id="Oval" cx="35" cy="35" r="35" fill="#0088FF" />
        <path
          d="m 41.5625,21.557368 c -2.23125,0 -4.156249,1.174769 -5.337501,2.953682 1.968751,1.812571 3.150001,4.296265 3.150001,7.149296 0,0.973415 -0.13125,1.846009 -0.393749,2.718772 0.831249,0.369168 1.662499,0.637685 2.581249,0.637685 3.63125,0 6.562501,-3.020896 6.562501,-6.712914 0,-3.692187 -2.931251,-6.712948 -6.562501,-6.712948 z m -13.125,3.356458 c -3.63125,0 -6.5625,3.020894 -6.5625,6.712913 0,3.692187 2.93125,6.712914 6.5625,6.712914 3.63125,0 6.5625,-3.020727 6.5625,-6.712914 0,-3.692019 -2.93125,-6.712913 -6.5625,-6.712913 z m 20.78125,10.606403 c -1.88125,1.711751 -4.4625,2.752379 -7.39375,2.819424 1.18125,1.275537 1.925,2.819424 1.925,4.497737 v 2.215177 h 8.75 v -5.571635 c 0,-1.745357 -1.35625,-3.255805 -3.28125,-3.99431 z m -28.4375,3.356459 C 18.85625,39.61519 17.5,41.125472 17.5,42.870829 v 5.571803 h 21.875 v -5.571803 c 0,-1.745357 -1.35625,-3.255639 -3.28125,-3.994141 -1.96875,1.778962 -4.6375,2.819423 -7.65625,2.819423 -3.01875,0 -5.6875,-1.074067 -7.65625,-2.819423 z"
          fill="#ffffff"
          id="path160"
        />
      </g>
    </svg>
  );
};
